export default __webpack_public_path__ + "static/media/profile.6c670cc5.png";